import React from 'react';
import PropTypes from 'prop-types';

const FirstPortfolioGuide = ({ jobCount, skillCount, projectCount, portfolioCount, onOpenJobs, onOpenSkills, onOpenProjects, onCreatePortfolio }) => {
  if (portfolioCount > 0) return null;

  const steps = [
    { key: 'account', title: 'Create your account', description: 'Your account is ready.', complete: true },
    { key: 'jobs', title: 'Choose desired jobs', description: 'Tell the AI which roles you want so it can tailor your portfolio.', complete: jobCount > 0, action: 'Add desired jobs', onAction: onOpenJobs },
    { key: 'skills', title: 'Add your skills', description: 'Record the abilities you want employers to notice.', complete: skillCount > 0, action: 'Add skills', onAction: onOpenSkills },
    { key: 'projects', title: 'Add a project', description: 'Show evidence of how you have used your skills.', complete: projectCount > 0, action: 'Add projects', onAction: onOpenProjects },
    { key: 'portfolio', title: 'Create your first portfolio', description: 'Let the AI turn your context into a tailored portfolio website.', complete: false, action: 'Create portfolio', onAction: onCreatePortfolio },
  ];
  const activeStep = steps.find((step) => !step.complete)?.key;
  const completedCount = steps.filter((step) => step.complete).length;

  return (
    <section className="card border-primary-subtle shadow-sm mb-4" aria-labelledby="first-portfolio-guide-title">
      <div className="card-body p-4">
        <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
          <div>
            <h2 id="first-portfolio-guide-title" className="h4 mb-1">Create your first portfolio</h2>
            <p className="text-muted mb-0">Follow these steps in order, or work at your own pace.</p>
          </div>
          <span className="badge text-bg-primary fs-6">{completedCount} of {steps.length} complete</span>
        </div>
        <div className="list-group">
          {steps.map((step, index) => (
            <div key={step.key} className={`p-2 list-group-item d-flex align-items-center gap-3 flex-wrap ${step.key === activeStep ? 'border-primary bg-primary-subtle' : ''}`}>
              <span className={`badge rounded-pill ${step.complete ? 'text-bg-success' : step.key === activeStep ? 'text-bg-primary' : 'text-bg-secondary'}`}>
                {step.complete ? <i className="bi bi-check-lg" aria-label="Complete"></i> : index + 1}
              </span>
              <div className="flex-grow-1">
                <h3 className="h6 mb-1">{step.title}</h3>
                <p className="small text-muted mb-0">{step.description}</p>
              </div>
              {!step.complete && step.onAction ? (
                <button type="button" className={`btn btn-sm ${step.key === activeStep ? 'btn-primary' : 'btn-outline-primary'}`} onClick={step.onAction}>
                  {step.action}
                </button>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

FirstPortfolioGuide.propTypes = {
  jobCount: PropTypes.number.isRequired,
  skillCount: PropTypes.number.isRequired,
  projectCount: PropTypes.number.isRequired,
  portfolioCount: PropTypes.number.isRequired,
  onOpenJobs: PropTypes.func.isRequired,
  onOpenSkills: PropTypes.func.isRequired,
  onOpenProjects: PropTypes.func.isRequired,
  onCreatePortfolio: PropTypes.func.isRequired,
};

export default FirstPortfolioGuide;
